import { useMutation } from 'urql'

const RECOVERY_PASSWORD = `mutation RESET_PASSWORD($input: ResetPasswordInput!) {
    resetPassword(input: $input) {
      status
      message
    }
  }
`

export const RecoveryPassword = () => {
  const [, recoveryPassword] = useMutation(RECOVERY_PASSWORD)
  // Wrapper para mantener compatibilidad con llamadas existentes
  return ({ email, isNewPepper }) => recoveryPassword({ input: { email, isNewPepper } })
}

const CHANGE_PASSWORD = `mutation CHANGE_PASSWORD(
    $input: ChangePasswordFromResetInput!
  ) {
  changePasswordFromReset(input : $input)
}
`

export const ChangePassword = () => {
  const [, changePassword] = useMutation(CHANGE_PASSWORD)
  return changePassword
}
